import { onMount } from "solid-js";
import { createMetricStream } from "../../primitives/createMetricStream.ts";
import { revealPanels } from "../../lib/reveal.ts";
import { registerHotkeys } from "../../lib/hotkeys.ts";
import { settings } from "../../stores/settings.ts";
import { StatusStrip } from "./StatusStrip.tsx";
import { PerformancePanel } from "../panels/PerformancePanel.tsx";
import { CDNPanel } from "../panels/CDNPanel.tsx";
import { WebVitalsPanel } from "../panels/WebVitalsPanel.tsx";
import { VideoPanel } from "../panels/VideoPanel.tsx";
import { DeployTimeline } from "../panels/DeployTimeline.tsx";
import { SprintPanel } from "../panels/SprintPanel.tsx";
import { AlertsFeed } from "../panels/AlertsFeed.tsx";
import { InfraPanel } from "../panels/InfraPanel.tsx";
import { TEDWisePanel } from "../panels/TEDWisePanel.tsx";
import { AdStackPanel } from "../panels/AdStackPanel.tsx";

export function Dashboard() {
  createMetricStream();
  registerHotkeys();

  let root!: HTMLDivElement;
  onMount(() => {
    void revealPanels(root);
  });

  return (
    <div
      ref={root}
      classList={{
        "relative h-screen flex flex-col gap-2 p-2.5 overflow-hidden": true,
        "presentation-mode": settings.presentationMode,
      }}
    >
      <StatusStrip />

      {/* Main grid — 12 columns, 3 rows, with the alerts feed tall on the right */}
      <div class="grid flex-1 grid-cols-12 grid-rows-3 gap-2 min-h-0">
        {/* Row 1: primary telemetry */}
        <PerformancePanel />
        <CDNPanel />
        <WebVitalsPanel />

        {/* Row 2: operational */}
        <DeployTimeline />
        <AlertsFeed />
        <InfraPanel />

        {/* Row 3: secondary + sprint */}
        <VideoPanel />
        <SprintPanel />
        <AdStackPanel />
      </div>

      {/* Bottom dock: TEDWise command line */}
      <TEDWisePanel />
    </div>
  );
}
